module.exports = __webpack_public_path__ + "img/active_icon.933adf3b.svg";